"use client";

import { Shield, Zap, CheckCircle, Layout, Lock, Smartphone } from "lucide-react";
import { SectionHeader } from "./SectionHeader";
import { usePathname } from "next/navigation";
import { getLocaleFromPathname } from "@/lib/i18n";
import { getSiteContent } from "@/lib/site-content";

const icons = [CheckCircle, Lock, Zap, Layout, Smartphone, Shield];

export function Team() {
  const pathname = usePathname() || "/";
  const locale = getLocaleFromPathname(pathname);
  const content = getSiteContent(locale).landing;

  return (
    <section id="features" className="container mx-auto px-4 md:px-6 py-12">
      <SectionHeader 
        title={content.featuresTitle} 
        description={content.featuresDescription}
      />
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {content.features.map((feature, index) => {
          const FeatureIcon = icons[index % icons.length];
          return (
          <div key={index} className="border border-positivus-dark rounded-[45px] p-8 shadow-[0_5px_0_0_#191A23] bg-white hover:bg-positivus-green transition-colors group">
            <div className="flex items-start justify-between mb-4">
               <div className="w-12 h-12 rounded-full border border-positivus-dark flex items-center justify-center bg-white group-hover:bg-positivus-dark group-hover:text-white transition-colors">
                  <FeatureIcon size={24} />
               </div>
            </div>
            
            <h3 className="text-xl font-bold mb-2">{feature.title}</h3>
            <p className="text-base text-gray-600 group-hover:text-black">
               {feature.description}
            </p>
          </div>
        )})}
      </div>
      
      <div className="hidden">
         {/* Hidden button area to maintain layout if needed, or remove completely */}
      </div>
    </section>
  );
}
